<template>
  <div id="topNav">
    <div class="topNavLogo" v-if="user">
      <router-link :to="`/topics/${user.id}`">
        <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.183 4.665c.099 0 .198.003.296.008a9.206 9.206 0 016.802 3.56 9.381 9.381 0 011.839 7.603c-.971 5.821-6.104 10.374-11.688 10.374a9.946 9.946 0 01-2.518-.325c.272.015.542.022.81.022a12.313 12.313 0 009.834-4.62c3.01-3.869 3.15-8.426.373-11.898-1.456-1.893-3.452-2.938-5.616-2.938-2.664 0-5.187 1.518-6.667 3.942a5.129 5.129 0 011.253-3.326 7.176 7.176 0 015.282-2.402zm-.165 3.307c3.05 0 5.605 1.69 6.51 4.304a7.416 7.416 0 01-.467 5.979c-1.315 2.528-4.05 4.646-7.136 5.528-.89.208-1.801.314-2.715.315-5.31 0-9.825-3.546-10.979-8.623a13.48 13.48 0 01-.102-.61 13.164 13.164 0 008.208 7.632 9.454 9.454 0 002.502.337c3.52 0 6.765-1.942 8.268-4.947 1.054-2.109 1.005-4.29-.138-6.14-1.186-1.919-3.427-3.243-5.894-3.543a8.368 8.368 0 011.943-.232zM6.572 1.39C3.225 4.499 1.69 9.37 2.94 13.747c1.225 3.27 4.384 5.795 7.689 6.163.204.015.4.023.593.023a6.659 6.659 0 005.424-2.69 7.185 7.185 0 001.303-5.198 6.079 6.079 0 01.425 4.754 6.374 6.374 0 01-4.44 4.38 8.654 8.654 0 01-2.741.45c-3.51 0-6.745-2.107-8.44-5.497C.589 11.44 1.325 4.528 6.298 1.557c.09-.056.182-.112.275-.167zm8.304 1.005a11.472 11.472 0 018.566 4.031 15.111 15.111 0 012.861 6.767 9.243 9.243 0 01-1.731 6.976 14.51 14.51 0 01-.424.62c1.106-2.583 1.309-5.404 1.309-7.124C25.09 8.15 20.412 3.68 15.028 3.68c-.222 0-.447.007-.67.022a6.854 6.854 0 00-5.886 3.775c-1.281 2.46-1.289 5.674-.087 8.314a5.594 5.594 0 01-1.918-2.825 8.242 8.242 0 01.74-6.217 8.583 8.583 0 017.67-4.354zM14.408.211c4.182.002 7.53 1.54 9.43 4.341-2.517-2.13-5.565-3.35-8.534-3.35A10.13 10.13 0 008.99 3.394c-2.355 1.765-3.78 4.313-3.907 6.985a8.146 8.146 0 002.775 6.481 6.075 6.075 0 004.056 1.43c.634-.006 1.265-.07 1.887-.19a6.555 6.555 0 01-2.739.56 10.557 10.557 0 01-2.897-.446 7.662 7.662 0 01-4.116-4.705 9.358 9.358 0 01.925-7.498c1.97-3.282 5.409-5.397 9.434-5.8z" fill="#5F5F5F" fill-rule="nonzero"/></svg>
        <span>VIR STORY CAPTURE PLATFORM</span>
      </router-link>
    </div>
    <div class="userNav" @mouseleave="userNavActive = false" v-if="user">
      <div @click="userNavActive = !userNavActive" class="userNavButton">
        Welcome, {{ user.firstName }}!
        <span class="chevron" :class="{ active: userNavActive }">
          <font-awesome-icon icon="chevron-down" />
        </span>
      </div>

      <div class="userNavMenuWrapper" :class="{ active: userNavActive }">
        <div class="userNavMenu">
          <ul>
            <li><router-link to="/about">Profile</router-link></li>
            <li>
              <a href="javascript:void(0)" @click="onClickLogout">Logout</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mobileMenu" @click="onClickMobileMenu">
      <font-awesome-icon icon="bars" v-if="!$store.state.ui.mobileMenu" />
      <font-awesome-icon icon="times" v-else />
    </div>
    <div class="mobileMenuList" v-if="$store.state.ui.mobileMenu">
      <div class="userNavMenu">
        <ul>
          <li><router-link to="/about" @click.native="mobileMenuClick">Profile</router-link></li>
          <li>
            <a href="javascript:void(0)" @click="onClickLogout">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      userNavActive: false,
    };
  },
  methods: {
    onClickLogout() {
      localStorage.removeItem("token");
      this.$store.dispatch("user", null);
      this.$router.push("/login");
      this.$store.dispatch("mobileMenu", false);
    },
    onClickMobileMenu() {
      this.$store.dispatch("mobileMenu", !this.$store.state.ui.mobileMenu);
    },
    mobileMenuClick(){
      this.$store.dispatch("mobileMenu", false);
    }
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<style lang="scss" scoped>
#topNav {
  background-image: url("~@/assets/header/gradient.jpg");
  background-size: 1px 1px;
  background-repeat: repeat;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  @media (max-width: $lg) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
    padding: 0 15px;
  }

  &:after {
    content: "";
    background-image: url("~@/assets/header/header-bg.jpg");
    background-size: 100% 60px;
    background-repeat: no-repeat;
    background-position: center top;
    width: 100%;
    height: 100%;
    display: block;

    @media (max-width: $lg) {
      display: none;
    }
  }
  .topNavLogo {
    position: absolute;
    top: 7px;
    left: 21%;

    @media (max-width: $lg) {
      position: relative;
      top: auto;
      left: auto;
    }

    span {
      font-family: Effra-Medium;
      font-size: 13px;
      color: #5f5f5f;
      margin-left: 8px;

      @media (max-width: $md) {
        display: none;
      }
    }
    a {
      text-decoration: none;
    }
  }
  .userNav {
    font-family: Effra-Medium;
    font-size: 12px;
    color: #5f5f5f;
    position: absolute;
    top: 11px;
    right: 20%;
    cursor: pointer;

    @media (max-width: $lg) {
      display: none;
    }
    .userNavButton {
      text-align: right;
      .chevron {
        margin-left: 5px;
        &.active {
          svg {
            transform: rotate(-180deg);
          }
        }
        svg {
          //transform: rotate(-90deg);
          transition: transform 0.25s ease-in-out;
          font-size: 10px;
        }
      }
    }
    .userNavMenuWrapper {
      max-height: 0px;
      overflow: hidden;
      transition: max-height 0.25s ease-in-out;
      &.active {
        max-height: 200px;
      }
      .userNavMenu {
        background: #fff;
        border-radius: 5px;
        margin-top: 5px;
        width: 150px;
        ul {
          list-style: none;
          margin: 0;
          padding: 0;
          li {
            border-bottom: 1px solid #e2e2e2;
            &:last-child {
              border-bottom: 0px;
            }
            a {
              display: block;
              text-align: center;
              padding: 10px 5px;
              text-decoration: none;
              color: #5f5f5f;
            }
          }
        }
      }
    }
  }
  .mobileMenu {
    display: none;
    @media (max-width: $lg) {
      display: block;
      svg {
        color: #5f5f5f;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .mobileMenuList {
    display: none;
    @media (max-width: $lg) {
      display: block;
    }
    position: absolute;
    top: 100%;
    right: 5px;
    margin-top: 5px;
    font-family: Effra-Medium;
    font-size: 13px;
    color: #5f5f5f;
    .userNavMenu {
      background: #fff;
      border-radius: 5px;
      width: 150px;
      ul {
        list-style: none;
        margin: 0;
        padding: 0;
        li {
          border-bottom: 1px solid #e2e2e2;
          &:last-child {
            border-bottom: 0px;
          }
          a {
            display: block;
            text-align: center;
            padding: 10px 5px;
            text-decoration: none;
            color: #5f5f5f;
          }
        }
      }
    }
  }
}
</style>